import SimpleImageSlider from "react-simple-image-slider";
import './css_files/react_image_slider.css';
import React, { useEffect, useState } from "react";
import axios from "axios";
import { url } from "../weburl";
// import { render } from "@testing-library/react";


const pedImages = [
  {
    url: 'https://res.cloudinary.com/daurieb51/image/upload/v1658103998/a_qgzlg5.jpg'

  },
  {
    url: 'https://res.cloudinary.com/daurieb51/image/upload/v1658178851/b_gc101u.jpg'
  }
]

const homeImages = [
  {
    url: 'https://res.cloudinary.com/daurieb51/image/upload/v1656539893/klrrqitouybfiyynbmlp.jpg'
  },

  { url: 'https://res.cloudinary.com/daurieb51/image/upload/v1655742937/khaki_mizhr9.jpg' },

  { url: "https://res.cloudinary.com/daurieb51/image/upload/v1682964518/home1_ij7gge.jpg"},

  
];

export const SliderC = (props) => {
  const [galleryImages, setGalleryImages] = useState()

  useEffect(()=> {
    console.log('here IN GALLERy images')
    axios
    .get(`${url}api/content/gallery-images/full-image-urls`)
    .then((res)=> {
      setGalleryImages(res.data)
      console.log('loging;,', res.data)
    })
    .catch((err)=>{
      console.log(err)
    })
  }, [])
    return (
      <div className="">

        {props.galleryImages && galleryImages &&
          <SimpleImageSlider
            width={'100%'}
            height={window.screen.width < 770 ? 350 : 550}
            images={galleryImages}
            showBullets={true}
            showNavs={true}
            loop={true}
            autoPlay={true}
            style={{ position: 'relative' }}
          />}
        {props.pedImages &&
          <SimpleImageSlider
            width={'100%'}
            height={window.screen.width < 770 ? 350 : 550}
            images={pedImages}
            showBullets={true}
            showNavs={true}
            loop={true}
            autoPlay={true}
            style={{ position: 'relative' }}
          />}

        {props.homeImages &&
          <SimpleImageSlider
            width={'100%'}
            height={window.screen.width < 770 ? 350 : 550}
            images={homeImages}
            showBullets={true}
            showNavs={true}
            loop={true}
            autoPlay={true}
            style={{ position: 'relative' }}
          />}


      </div>
    );
  

}